import React from "react";
import { Panel, Table, Loader } from "@culturehq/components";
import * as CHQ from "chq";

import { useGet } from "app/hooks";
import { StoryTrendLink } from "app/links";
import { Trans, formatThousand } from "app/utils";

type StoryQuestionAnalyticsProps = {
  storyQuestionAnalytics: CHQ.StoryQuestionAnalytics;
};

const StoryQuestionAnalytics: React.FC<StoryQuestionAnalyticsProps> = (
  { storyQuestionAnalytics }
) => (
  <tr>
    <td className="max-width-300">
      <StoryTrendLink storyQuestion={storyQuestionAnalytics.storyQuestion}>
        {storyQuestionAnalytics.storyQuestion.question}
      </StoryTrendLink>
    </td>
    <td className="txt-center">
      {formatThousand(storyQuestionAnalytics.usersCount)}
    </td>
    <td className="txt-center">
      {formatThousand(storyQuestionAnalytics.storiesCount)}
    </td>
    <td className="txt-center">
      {formatThousand(storyQuestionAnalytics.cheersCount)}
    </td>
    <td className="txt-center">
      {formatThousand(storyQuestionAnalytics.commentsCount)}
    </td>
  </tr>
);

export type ListStoryQuestionAnalytics = {
  storyQuestions: CHQ.StoryQuestionAnalytics[];
};

const HighestPerformingPromptsContent: React.FC = () => {
  const get = useGet<ListStoryQuestionAnalytics>("/analytics/story_questions");

  if (get.getting) {
    return <Loader loading />;
  }

  if (get.error) {
    throw get.error;
  }

  return (
    <Table className="table-responsive">
      <thead>
        <tr>
          <th>
            <Trans>Story Title</Trans>
          </th>
          <th className="txt-center">
            <Trans>Users</Trans>
          </th>
          <th className="txt-center">
            <Trans>Stories</Trans>
          </th>
          <th className="txt-center">
            <Trans>Cheers</Trans>
          </th>
          <th className="txt-center">
            <Trans>Comments</Trans>
          </th>
        </tr>
      </thead>
      <tbody>
        {get.got.storyQuestions.map(storyQuestionAnalytics => (
          <StoryQuestionAnalytics
            key={storyQuestionAnalytics.storyQuestion.id}
            storyQuestionAnalytics={storyQuestionAnalytics}
          />
        ))}
      </tbody>
    </Table>
  );
};

const HighestPerformingPrompts: React.FC = () => (
  <Panel>
    <Panel.Body className="card_holder">
      <div className="card_title">
        <h3>
          <Trans>Highest-Performing Prompts</Trans>
        </h3>
        {
        /*
        <Button className="view_link">
          <Link to="/admin/story-questions">
            <Trans>View all</Trans>
          </Link>
        </Button>
        */
        }
      </div>
      <div className="card_info">
        <div className="w-100">
          <HighestPerformingPromptsContent />
        </div>
      </div>
    </Panel.Body>
  </Panel>
);

export default HighestPerformingPrompts;
